/*
  VAULT quick add ("VAULT LOCK") for product cards built by JavaScript:
  Recommended for You, Style With and Recently Viewed.
  Mirrors the collection grid (blocks/ai_gen_block_47e4a6f.liquid):
  - rest 0.65s on a card -> photo dims, ADD TO CART + plus appear
  - stays while inside the card; 5s with no interaction (or a swipe) fades it out
  - only the centered box adds; the rest of the card still opens the product
  - + spins into a lock, shackle drops, lock goes solid, photo brightens
  A card opts in with data-ql-variant="<variant id>" (sold-out cards leave it off).
*/
(function () {
  if (window.VaultQuickLock) return;

  var IDLE_MS = 650;
  var TIMEOUT_MS = 5000;
  var EASE = 'cubic-bezier(.22, 1, .36, 1)';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var active = null;

  var css = [
    '.vql-host{container-type:inline-size;}',
    '.vql-host.vql-static{position:relative;}',
    '.vql-host.vql-on.vql-on.vql-on{z-index:2;}',
    '.card__inner:has(.vql-host.vql-on){position:relative;z-index:2;}',
    '.vql-dim{position:absolute;inset:0;z-index:6;background:#fff;opacity:0;pointer-events:none;transition:opacity .3s ease;}',
    '.vql-host.vql-on .vql-dim{opacity:.6;transition:opacity .6s ease;}',
    '.vql-host.vql-release .vql-dim{transition:opacity 1s cubic-bezier(.22,1,.36,1);}',
    '.vql-atc{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:72%;z-index:9;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:18px;margin:0;padding:20px 0;border:0;background:transparent;color:#fff;opacity:0;pointer-events:none;-webkit-tap-highlight-color:transparent;font:inherit;}',
    '.vql-host.vql-on .vql-atc{pointer-events:auto;cursor:pointer;}',
    '.vql-host.vql-on .vql-atc:active .vql-plus{transform:scale(.9);transition:transform .12s ease-out;}',
    '.vql-label{font-family:"Archivo Narrow",Arial,sans-serif;font-size:11px;font-weight:600;line-height:1;letter-spacing:.2em;padding-left:.2em;white-space:nowrap;}',
    '.vql-plus{position:relative;width:16px;height:16px;}',
    '.vql-plus>span{position:absolute;left:50%;top:50%;width:16px;height:1.5px;background:currentColor;transform:translate(-50%,-50%);}',
    '.vql-plus>span+span{transform:translate(-50%,-50%) rotate(90deg);}',
    '.vql-added{display:flex;z-index:10;color:#fff;mix-blend-mode:difference;pointer-events:none;}',
    '.vql-lock svg{display:block;width:100%;height:100%;overflow:visible;transform:scale(1.25);}',
    '.vql-lock path{fill:currentColor;fill-opacity:0;stroke:currentColor;stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round;transform-box:fill-box;transform-origin:center;}',
    '.vql-lock .vql-shackle{fill:none;}',
    '@media screen and (min-width:750px){',
    '.vql-atc{gap:max(18px,9.4cqw);padding:max(20px,11cqw) 0;}',
    '.vql-label{font-size:max(11px,4.75cqw);}',
    '.vql-plus,.vql-plus>span{width:max(16px,6.4cqw);}',
    '.vql-plus{height:max(16px,6.4cqw);}',
    '.vql-plus>span{height:max(1.5px,.55cqw);}',
    '.vql-lock path{stroke-width:max(1.5px,.55cqw);}',
    '}'
  ].join('\n');

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function anim(el, frames, ms, delay, easing, fill) {
    if (!el) return Promise.resolve();
    var a = el.animate(frames, {
      duration: reduced ? Math.min(ms, 240) : ms,
      delay: reduced ? 0 : (delay || 0),
      easing: easing || EASE,
      fill: fill || 'both'
    });
    return a.finished.catch(function () {});
  }

  function wait(ms) {
    return new Promise(function (r) { setTimeout(r, reduced ? Math.min(ms, 400) : ms); });
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;
        document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(function (el) {
          var target = el.querySelector('span') || el;
          target.textContent = count;
          if (count > 0) {
            el.classList.remove('hidden', 'is-empty');
            el.setAttribute('aria-hidden', 'false');
          } else {
            el.classList.add('hidden', 'is-empty');
            el.setAttribute('aria-hidden', 'true');
          }
        });
        document.dispatchEvent(new CustomEvent('cart:count-updated', { detail: { count: count } }));
      })
      .catch(function (err) { console.error(err); });
  }

  function setup(card) {
    if (card.__vql) return card.__vql;

    var variant = Number(card.getAttribute('data-ql-variant'));
    // Our rows use *image-wrapper; Dawn cards (search page) use .card__media.
    var host = card.querySelector('[class*="image-wrapper"], .card__media');
    if (!variant || !host) return (card.__vql = null);

    host.classList.add('vql-host');
    if (getComputedStyle(host).position === 'static') host.classList.add('vql-static');
    var dim = document.createElement('span');
    dim.className = 'vql-dim';
    host.appendChild(dim);

    // Dawn's image is not a link (a stretched title link covers it). While ADD TO CART
    // lifts the photo above that link, a click off the box still opens the product.
    if (!host.closest('a')) {
      host.addEventListener('click', function (e) {
        if (e.target.closest('.vql-atc')) return;
        var link = card.querySelector('a[href*="/products/"]');
        if (link) link.click();
      });
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vql-atc';
    btn.setAttribute('aria-label', 'Add to cart');
    btn.innerHTML = '<span class="vql-label">ADD TO CART</span>'
      + '<span class="vql-plus" aria-hidden="true"><span></span><span></span></span>';
    host.appendChild(btn);

    var st = { on: false, busy: false, overBox: false, inside: false, idle: null, timeout: null, touch: null, suppressUntil: 0 };

    function restartTimeout() {
      clearTimeout(st.timeout);
      st.timeout = null;
      if (st.on && !st.overBox) st.timeout = setTimeout(fadeOut, TIMEOUT_MS);
    }

    function show() {
      st.idle = null;
      if (st.busy || !btn.isConnected || !st.inside) return;
      if (active && active !== api) active.fadeOut();
      active = api;
      btn.style.transition = 'opacity 1s ease';
      btn.style.opacity = '1';
      host.classList.remove('vql-release');
      host.classList.add('vql-on');
      st.on = true;
      restartTimeout();
    }

    function hide(smooth) {
      clearTimeout(st.timeout);
      st.timeout = null;
      if (!btn.isConnected || st.busy) return;
      if (smooth) host.classList.add('vql-release');
      host.classList.remove('vql-on');
      btn.style.transition = smooth ? 'opacity .6s ease' : 'opacity .3s ease';
      btn.style.opacity = '0';
      st.on = false;
    }

    function fadeOut() { if (st.on) hide(true); }

    // Resting (no movement) for 0.65s shows it; movement while shown only restarts the 5s.
    function activity() {
      if (st.busy) return;
      if (st.on) { restartTimeout(); return; }
      clearTimeout(st.idle);
      st.idle = setTimeout(show, IDLE_MS);
    }

    function swiped() {
      fadeOut();
      clearTimeout(st.idle);
      st.idle = st.inside ? setTimeout(show, IDLE_MS) : null;
    }

    card.addEventListener('mouseenter', function () { st.inside = true; activity(); });
    card.addEventListener('mousemove', activity, { passive: true });
    card.addEventListener('mouseleave', function () {
      st.inside = false;
      clearTimeout(st.idle);
      st.idle = null;
      hide(false);
    });

    btn.addEventListener('mouseenter', function () { st.overBox = true; restartTimeout(); });
    btn.addEventListener('mouseleave', function () { st.overBox = false; restartTimeout(); });

    // Phones: hold still 0.65s to reveal it, a quick tap still opens the product.
    card.addEventListener('touchstart', function (e) {
      st.inside = true;
      st.touch = { x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now(), revealed: false };
      if (st.on) { restartTimeout(); return; }
      clearTimeout(st.idle);
      st.idle = setTimeout(function () { show(); if (st.touch) st.touch.revealed = st.on; }, IDLE_MS);
    }, { passive: true });

    card.addEventListener('touchmove', function (e) {
      if (!st.touch) return;
      var dx = Math.abs(e.touches[0].clientX - st.touch.x);
      var dy = Math.abs(e.touches[0].clientY - st.touch.y);
      if (dx > 10 || dy > 10) {
        clearTimeout(st.idle);
        st.idle = null;
        if (dx > dy) fadeOut();
      }
    }, { passive: true });

    card.addEventListener('touchend', function () {
      if (st.touch && st.touch.revealed) st.suppressUntil = Date.now() + 600;
      if (!st.on) { clearTimeout(st.idle); st.idle = null; }
      st.touch = null;
    }, { passive: true });

    // The hold that revealed ADD TO CART must not also open the product.
    card.addEventListener('click', function (e) {
      if (Date.now() < st.suppressUntil) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    card.addEventListener('contextmenu', function (e) {
      if (st.touch || st.on) e.preventDefault();
    });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (st.on) addToCart();
    });

    function addToCart() {
      if (!btn.isConnected || st.busy) return;
      st.busy = true;
      clearTimeout(st.timeout);

      var label = btn.querySelector('.vql-label');
      var plus = btn.querySelector('.vql-plus');
      var breathe = null;
      var settled = false;

      var request = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variant, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      });

      request.then(function () { settled = true; }, function () { settled = true; });

      // 1. + tightens and waits; it breathes if Shopify is slow, never claims success early.
      var press = anim(plus, [{ transform: 'scale(.72)' }], 360).then(function () {
        if (!settled && !reduced) {
          breathe = plus.animate([{ opacity: 1 }, { opacity: .45 }], {
            duration: 800, direction: 'alternate', iterations: Infinity, easing: 'ease-in-out'
          });
        }
      });

      press.then(function () { return request; }).then(function (vaultItem) {
        try { (vaultItem && vaultItem.items ? vaultItem.items : [vaultItem]).forEach(function (x) { if (x && x.product_id) document.dispatchEvent(new CustomEvent('vault:cart-added', { detail: { productId: x.product_id, variantId: x.variant_id || x.id } })); }); } catch (vaultErr) {} // VAULT personalization: successful add
        // The header's bag takes over the count when it can (sections/ss-header-9.liquid).
        var receive = window.VaultCartReceive;
        if (!receive) updateCartCount();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (breathe) breathe.cancel();

        var added = document.createElement('div');
        added.className = 'vql-atc vql-added';
        added.setAttribute('aria-live', 'polite');
        added.innerHTML = '<span class="vql-label">ADDED</span>'
          + '<span class="vql-plus vql-lock" aria-hidden="true"><svg viewBox="0 0 24 24">'
          + '<path class="vql-shackle" d="M7.5 11V7.5a4.5 4.5 0 0 1 9 0V11" vector-effect="non-scaling-stroke"/>'
          + '<path class="vql-body" fill-rule="evenodd" vector-effect="non-scaling-stroke" '
          + 'd="M6.5 11h11a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2z'
          + 'M12 14.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 1 0 0-3z"/></svg></span>';
        host.appendChild(added);
        added.style.opacity = '1';

        var icon = added.lastChild;
        var shackle = added.querySelector('.vql-shackle');
        var body = added.querySelector('.vql-body');
        var addedLabel = added.firstChild;
        var MORPH = 'cubic-bezier(.45, 0, .2, 1)';

        // 2. Morph: half a turn with motion blur, overshoot, settle into an open lock.
        anim(plus, [{ opacity: 1 }, { opacity: 0 }], 260);
        anim(icon, [
          { opacity: 0, transform: 'rotate(-180deg) scale(.576)', filter: 'blur(0)' },
          { opacity: 1, offset: .2, filter: 'blur(1.2px)' },
          { offset: .4, filter: 'blur(2.2px)' },
          { transform: 'rotate(-12deg) scale(1.2)', offset: .7, filter: 'blur(.6px)' },
          { opacity: 1, transform: 'rotate(0deg) scale(1)', filter: 'blur(0)' }
        ], 820, 0, MORPH);
        anim(body, [
          { transform: 'translate(0, -4px) scale(1.07, .1)' },
          { transform: 'translate(0, .6px) scale(1.14, 1.14)', offset: .62 },
          { transform: 'translate(0, 0) scale(1, 1)' }
        ], 820, 0, MORPH);
        anim(shackle, [
          { transform: 'translate(0, 5px) scale(.02, 2)' },
          { transform: 'translate(0, -8px) scale(1.12, 1.12)', offset: .62 },
          { transform: 'translate(0, -5px) scale(1, 1)' }
        ], 820, 0, MORPH);

        // 3. Shackle drops shut: accelerates, smears on the way down, lands.
        var DROP_AT = 1150, DROP_MS = 520, IMPACT = DROP_AT + DROP_MS * .7;
        anim(shackle, [
          { transform: 'translate(0, -5px) scale(1, 1)', easing: 'cubic-bezier(.55, 0, 1, .45)' },
          { transform: 'translate(0, .8px) scale(1, 1.14)', offset: .7, easing: 'cubic-bezier(0, .55, .45, 1)' },
          { transform: 'translate(0, 0) scale(1, 1)' }
        ], DROP_MS, DROP_AT, 'linear', 'forwards');
        anim(icon, [
          { filter: 'blur(0)' },
          { filter: 'blur(1.1px)', offset: .6 },
          { filter: 'blur(0)', offset: .85 },
          { filter: 'blur(0)' }
        ], DROP_MS, DROP_AT, 'linear', 'forwards');

        // Impact: body takes the hit, floods solid, photo returns to full.
        anim(body, [
          { transform: 'translate(0, 0)' },
          { transform: 'translate(0, .9px)', offset: .35 },
          { transform: 'translate(0, 0)' }
        ], 320, IMPACT, null, 'forwards');
        var solid = anim(body, [{ fillOpacity: 0 }, { fillOpacity: 1 }], 380, IMPACT);
        anim(icon, [
          { transform: 'scale(1)' },
          { transform: 'scale(1.08)', offset: .4 },
          { transform: 'scale(1)' }
        ], 420, IMPACT, null, 'forwards');
        setTimeout(function () {
          host.classList.add('vql-release');
          host.classList.remove('vql-on');
        }, reduced ? 0 : IMPACT);

        // ADD TO CART blurs out; ADDED sharpens in, in the same spot.
        anim(label, [{ opacity: 1, filter: 'blur(0)' }, { opacity: 0, filter: 'blur(3px)' }], 560);
        anim(addedLabel, [{ opacity: 0, filter: 'blur(3px)' }, { opacity: 1, filter: 'blur(0)' }], 700, 320);

        // 4. Hold on the solid lock, then fade away. The card goes back to a plain link.
        return solid.then(function () {
          if (receive) receive(icon);
          return wait(1100);
        }).then(function () {
          return anim(added, [{ opacity: 1, filter: 'blur(0)' }, { opacity: 0, filter: 'blur(2px)' }], 700);
        }).then(function () {
          added.remove();
          btn.remove();
          st.on = false;
          host.classList.remove('vql-release');
        });
      }).catch(function (err) {
        console.error(err);
        if (breathe) breathe.cancel();
        // Not added: the + opens back up, nothing claims success.
        return anim(plus, [{ transform: 'scale(.72)' }, { transform: 'scale(1)' }], 420).then(function () {
          if (plus) plus.getAnimations().forEach(function (a) { a.cancel(); });
        });
      }).then(function () {
        st.busy = false;
        if (st.on) restartTimeout();
      });
    }

    var api = { card: card, fadeOut: fadeOut, swiped: swiped, state: st };
    card.__vql = api;
    return api;
  }

  function cardFrom(target) {
    return target && target.closest ? target.closest('[data-ql-variant]') : null;
  }

  // Cards are re-rendered with innerHTML, so wire each one on first contact.
  function onFirstContact(e) {
    var card = cardFrom(e.target);
    if (!card || card.__vql !== undefined) return;
    var api = setup(card);
    if (!api) return;
    if (e.type === 'mouseover') { api.state.inside = true; card.dispatchEvent(new MouseEvent('mouseenter')); }
  }
  document.addEventListener('mouseover', onFirstContact, true);
  document.addEventListener('touchstart', function (e) {
    onFirstContact(e);
    // Touching anywhere else puts the open card back to normal.
    if (active && !active.card.contains(e.target)) { active.state.inside = false; active.fadeOut(); }
  }, { capture: true, passive: true });

  // Carousel drag, trackpad swipe or glide scrolls the row: fade out, come back once it settles.
  document.addEventListener('scroll', function (e) {
    var row = e.target;
    if (!active || !row || row === document || !row.contains) return;
    if (row.contains(active.card)) active.swiped();
  }, true);

  window.VaultQuickLock = { setup: setup };
})();
